import { Button, Card, Progress } from '@material-tailwind/react';
import { useState } from 'react';
import { getZenRowsUsage } from '../fb-functions';
import Loading from '../widgets/layout/loading';

export default function ZenRowsUsageCard() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);

 

  const fetchUsage = async () => {
    try {
      const response = await getZenRowsUsage(); // proxy endpoint
      console.log(response)
      setUsage(response.data);
    } catch (error) {
      console.error('Failed to fetch usage data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading){
    return <Loading></Loading>
  }

  return (
    <Card className="max-w-xl p-6 space-y-4 shadow-lg">
      <div>
        <h2 className="text-xl font-bold">ZR API  Usage</h2>
        <Progress value={usage?.usage_percent} />
        <div className="mt-2 flex justify-between text-sm">
          <p>{usage?.usage_percent}%</p>
        </div>
      </div>
      <Button onClick={fetchUsage} className="w-full">
          Refresh Usage
        </Button>
 
  </Card>
  
  );
}
